export const ITEM_DESCRIPTION_MAX = 500;
export const ADDRESS_LINE_MAX = 100;
export const CUSTOMER_NAME_MAX = 60;
export const VARIANT_CUSTOMISATION_TEXT_MAX = 60;
